var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6894 5.8212C18.2753 5.40709 17.6064 5.40709 17.1923 5.8212L12 11.0028L6.80774 5.81058C6.39363 5.39647 5.72469 5.39647 5.31058 5.81058C4.89647 6.22469 4.89647 6.89363 5.31058 7.30774L10.5028 12.5L5.31058 17.6923C4.89647 18.1064 4.89647 18.7753 5.31058 19.1894C5.72469 19.6035 6.39363 19.6035 6.80774 19.1894L12 13.9972L17.1923 19.1894C17.6064 19.6035 18.2753 19.6035 18.6894 19.1894C19.1035 18.7753 19.1035 18.1064 18.6894 17.6923L13.4972 12.5L18.6894 7.30774C19.0929 6.90425 19.0929 6.22469 18.6894 5.8212Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.f542fdb23f13a49086fa81f5fa987ef9.svg";
export { ForwardRef as ReactComponent };